export const feBaseURL = 'localhost:3000';

export const landingPageRoute = '/';

export const goalsPageRoute = '/goals';
export const setGoalPageRoute = '/goals/set';
export const singleGoalPageRoute = '/goals/goal';
export const editGoalPageRoute = '/goals/goal/edit';

export const tasksPageRoute = '/tasks';
export const singleTaskPageRoute = '/tasks/task';